import { Injectable } from '@angular/core';
import { ConfigService } from '../config/config.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class CotizacionService {

  constructor(private config: ConfigService,
    private http: HttpClient) { }

  getListOfPrice = (token: string) => {
    const requestOptions = new Object({
      headers: new HttpHeaders().append('Authorization', `Bearer ${token}`)
    });
    const url = this.config.urlService + "api/Cotizacion/listOfPrice";
    return this.http.get(url, requestOptions);
  }

  getListStatesQuotation = (token: string) => {
    const requestOptions = new Object({
      headers: new HttpHeaders().append('Authorization', `Bearer ${token}`)
    });
    const url = this.config.urlService + "api/Cotizacion/listStates";
    return this.http.get(url, requestOptions);
  }

  getCotizacion = (token: string, idCliente: number, idListaPrecios: number) => {
    const requestOptions = new Object({
      headers: new HttpHeaders().append('Authorization', `Bearer ${token}`)
    });
    const url = this.config.urlService + "api/Cotizacion/" + idCliente + "/" + idListaPrecios;
    return this.http.get(url, requestOptions);
  }

  getCotizacionesInProcessCustomer = (token: string, identification: number) => {
    const requestOptions = new Object({
      headers: new HttpHeaders().append('Authorization', `Bearer ${token}`)
    });
    const url = this.config.urlService + "api/Cotizacion/InProcessCustomer/" + identification;
    return this.http.get(url, requestOptions);
  }

  getCotizacionesInProcess = (token: string, startdate: string, enddate: string) => {
    const requestOptions = new Object({
      headers: new HttpHeaders().append('Authorization', `Bearer ${token}`)
    });
    const url = this.config.urlService + "api/Cotizacion/InProcess/" + startdate + "/" + enddate;
    return this.http.get(url, requestOptions);
  }

  getCotizacionesCompleted = (token: string, startdate: string, enddate: string) => {
    const requestOptions = new Object({
      headers: new HttpHeaders().append('Authorization', `Bearer ${token}`)
    });
    const url = this.config.urlService + "api/Cotizacion/Completed/" + startdate + "/" + enddate;
    return this.http.get(url, requestOptions);
  }

  getCotizacionesNoTracked = (token: string) => {
    const requestOptions = new Object({
      headers: new HttpHeaders().append('Authorization', `Bearer ${token}`)
    });
    const url = this.config.urlService + "api/Cotizacion/NoTracked";
    return this.http.get(url, requestOptions);
  }


  getCotizacionByNumber = (token: string, idCotizacion: number) => {
    const requestOptions = new Object({
      headers: new HttpHeaders().append('Authorization', `Bearer ${token}`)
    });
    const url = this.config.urlService + "api/Cotizacion/" + idCotizacion;
    return this.http.get(url, requestOptions);
  }

  updateQSKUCotizacion = (token: string, data: any) => {
    const requestOptions = new Object({
      headers: new HttpHeaders().append('Authorization', `Bearer ${token}`)
    });
    const url = this.config.urlService + "api/Cotizacion/ItemsInicial";
    return this.http.put(url, data, requestOptions);
  }

  editCotizacion = (token: string, data: any) => {
    const requestOptions = new Object({
      headers: new HttpHeaders().append('Authorization', `Bearer ${token}`)
    });
    const url = this.config.urlService + "api/Cotizacion/editQuotation";
    return this.http.post(url, data, requestOptions);
  }

  setCotizacion = (token: string, data: any) => {
    const requestOptions = new Object({
      headers: new HttpHeaders().append('Authorization', `Bearer ${token}`)
    });
    const url = this.config.urlService + "api/Cotizacion";
    return this.http.post(url, data, requestOptions);
  }

  setCotizacionShipping = (token: string, data: any) => {
    const requestOptions = new Object({
      headers: new HttpHeaders().append('Authorization', `Bearer ${token}`)
    });
    const url = this.config.urlService + "api/Cotizacion/editShipping";
    return this.http.post(url, data, requestOptions);
  }

  setCotizacionShippingValue = (token: string, data: any) => {
    const requestOptions = new Object({
      headers: new HttpHeaders().append('Authorization', `Bearer ${token}`),
      responseType: 'text'
    });
    const url = this.config.urlService + "api/Cotizacion/editShippingValue";
    return this.http.post(url, data, requestOptions);
  }

  setTrackingCotizacion = (token: string, data: any, idCotizacion: number) => {
    const requestOptions = new Object({
      headers: new HttpHeaders().append('Authorization', `Bearer ${token}`),
      responseType: 'text'
    });
    const url = this.config.urlService + "api/Cotizacion/setTracking/" + idCotizacion;
    return this.http.post(url, data, requestOptions);
  }

  setEnviarCotizacion = (token: string, data: any, option: number) => {
    const requestOptions = new Object({
      headers: new HttpHeaders().append('Authorization', `Bearer ${token}`),
      responseType: 'text'
    });
    const url = this.config.urlService + "api/Cotizacion/EnviarCliente/" + option;
    return this.http.post(url, data, requestOptions);
  }

  setReenviarCotizacion = (token: string, email: string, idCotizacion: number) => {
    const requestOptions = new Object({
      headers: new HttpHeaders().append('Authorization', `Bearer ${token}`),
      responseType: 'text'
    });
    const url = this.config.urlService + "api/Cotizacion/SendEmail/" + idCotizacion + "/" + email;
    return this.http.post(url, {}, requestOptions);
  }

}
